import { Component, OnInit } from '@angular/core';
import { MedigiComponentCopyService } from '../../../medigi/medigi-component-copy.service';

@Component({
  selector: 'app-drug-card',
  templateUrl: './drug-card.component.html',
  styleUrls: ['./drug-card.component.scss'],
})
export class DrugCardComponent implements OnInit {
  drugCards;

  constructor(private medigiCopyService: MedigiComponentCopyService) {}

  ngOnInit() {
    this.getDrugCards();
  }

  getDrugCards() {
    this.drugCards = this.medigiCopyService.cards.drugCards;
  }
}
